<template>
  <span
    :class="{
      tag: true,
      disabled,
      'v-success': variant === 'success',
      'v-danger': variant === 'danger',
      'v-warning': variant === 'warning'
    }"
    @click="$emit('click')"
  >
    <CGButton v-if="showRemove" class="tag-remove" variant="ghost" :disabled="disabled" :aria-label="$t('Wcag.RemoveTag')" @click="$emit('remove')">
      <Icon name="close" aria-hidden />
    </CGButton>
    <span class="tag-content">
      <slot />
    </span>
  </span>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    showRemove: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String, // 'success' | 'danger' | 'warning'
      default: undefined,
    },
  },

  emits: ['click', 'remove'],
});
</script>

<style lang="scss" scoped>
.tag {
  @apply inline-flex items-center;
  @apply bg-soft-blue-300;
  @apply text-xs;
  @apply h-7 px-2.5 rounded-lg;
  @apply cursor-default;
  @apply transition-colors duration-200 ease-in-out;
  @apply hover:bg-soft-blue-500;

  &.disabled {
    @apply bg-primary-100 text-primary-500/70;
    @apply cursor-not-allowed;
  }
  &.v-success {
    @apply bg-green-700 text-white font-bold;
    @apply hover:bg-green-600;
    .icon{
      @apply text-white;
    }
  }
  &.v-danger {
    @apply bg-red-900 text-white font-bold ;
    @apply hover:bg-red-800;
    .icon{
      @apply text-white;
    }
  }
  &.v-warning {
    @apply bg-yellow-500 text-gray-900 font-bold;
    @apply hover:bg-yellow-700;

    .icon {
      @apply text-black;
    }
  }
}



.tag-content {
  @apply -mb-1; // font-adjustment
}

.tag-remove {
  @apply mr-0.5;
  @apply -ml-1; // icon adjustment

  .disabled & {
    .icon {
      @apply text-primary-300;
    }
  }
}
</style>
